import { INavList } from 'app/interfaces/nav-list/navList.interface';
import ROUTER_PATH from 'app/routes/routerPath';

const NAV_LIST: INavList[] = [
	{
		label: 'Profil',
		path: '',
	},
	{
		label: 'Deposit',
		path: '',
	},
	{
		label: 'Tarik Dana',
		path: '',
	},
	{
		label: 'Ubah Kata Sandi',
		path: '',
	},
	{
		label: 'Keluar',
		path: ROUTER_PATH.login,
	},
];

export default NAV_LIST;
